export default class FetchSnippetRevisions {
  constructor(context) {
    this.context = context;
  }

  run(snippetId) {
    this.context.gateways.snippetRevision.request({ snippetId });
  }
}
